import './polyfills';
// eslint-disable-next-line no-use-before-define
import { ThemedGlobalStyle } from '@/theme';
import ThemeProvider from '@/theme/ThemeProvider';
import StyledEngineProvider from '@mui/material/StyledEngineProvider';
import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { WagmiProvider } from 'wagmi';
import App from './App';

import './index.css';

import config from '@/common-helpers/web3modalconfig';
import { DefaultChainId } from '@/constant';
import '@/utils/i18n';
import { RainbowKitProvider } from '@rainbow-me/rainbowkit';
import '@rainbow-me/rainbowkit/styles.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BigNumber } from 'bignumber.js';
import { configure } from 'mobx';
import { ApolloMultiClientProvider } from './ApolloMultiClientProvider';

configure({
    enforceActions: 'always',
});

BigNumber.set({ ROUNDING_MODE: BigNumber.ROUND_DOWN });

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
);

root.render(
    <Suspense fallback={<></>}>
        <WagmiProvider config={config}>
            <QueryClientProvider client={queryClient}>
                <RainbowKitProvider
                    initialChain={DefaultChainId}
                    showRecentTransactions={true}
                    appInfo={{
                        appName: 'LazAI Testnet',
                    }}
                >
                    <ApolloMultiClientProvider>
                        <StyledEngineProvider injectFirst>
                            <BrowserRouter>
                                <ThemeProvider>
                                    <ThemedGlobalStyle />
                                    <App />
                                </ThemeProvider>
                            </BrowserRouter>
                        </StyledEngineProvider>
                    </ApolloMultiClientProvider>
                </RainbowKitProvider>
            </QueryClientProvider>
        </WagmiProvider>
    </Suspense>,
);
